import { PlusIcon, RadioInput, Row } from 'smoothie';

import {
    formatPaymentMethodLabel,
    type PaymentMethodSummary,
} from '../hooks/usePaymentMethod';
import CardBrandIcon from './CardBrandIcon';

interface CreditCardPickerProps {
    savedCard: PaymentMethodSummary;
    useNewCard: boolean;
    disabled?: boolean;
    onSelectSaved: () => void;
    onSelectNew: () => void;
}

/** Saved-card-vs-new-card radio rows, shared by both checkout platforms. */
const CreditCardPicker = ({
    savedCard,
    useNewCard,
    disabled = false,
    onSelectSaved,
    onSelectNew,
}: CreditCardPickerProps) => (
    <>
        <Row
            title={formatPaymentMethodLabel(savedCard)}
            leftContentOverride={<CardBrandIcon brand={savedCard.brand} />}
            onPress={disabled ? undefined : onSelectSaved}
            rightContent={
                <RadioInput
                    isSelected={!useNewCard}
                    disabled={disabled}
                    onPress={onSelectSaved}
                />
            }
        />
        <Row
            title="Use another payment method"
            leftIcon={PlusIcon}
            onPress={disabled ? undefined : onSelectNew}
            rightContent={
                <RadioInput
                    isSelected={useNewCard}
                    disabled={disabled}
                    onPress={onSelectNew}
                />
            }
        />
    </>
);

export default CreditCardPicker;
